import CwLoadModules from '@customjs/module-loader.js';
import { __esModule } from 'js-match-height';

const CwThemeFramework = {
    async generalFns() {
        const office = document.querySelector('.select-office');
        if (office) {
            this.loadLocations(office);
            office.addEventListener('change', () => this.loadLocations(office));
        }

        // add .toc-exclude class to faq section heading tags.
        const faqTitles = document.querySelectorAll('.qa-faq-title');
        const faqHeading = document.querySelector('.faq-catname');

        faqTitles.forEach(title => {
            title.classList.add('toc-exclude');
        });

        if (faqHeading) {
            faqHeading.classList.add('toc-exclude');
        }

    },

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const officeMap = document.querySelector('.office-map');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<strong>P: </strong><a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone">${phone}</a>` :
                    '';
                const emailHTML = email ?
                    `<strong>E: </strong><a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                    <a href="${directionURL}" target="_blank" aria-label="Direction Link">Directions</a>
                    <button class="btn btn-nb cw-modal" data-cw-target="#hoursModal" id="office-hours">Hours</button>
               </div>`;

                const footerMapHTML = footer_map ?
                    `<figure><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img src="${footer_map}" alt="${firmName}" /></a></figure>` :
                    '';

                const address = `${firmNameHTML}
               <address>
                   ${address1HTML}<br>
                   ${address2HTML}<br>
                   <span>${city}, ${state} ${zip}</span><br>
               </address>
               ${phoneHTML}<br>
               ${emailHTML}${officeInfoButtons}`;
                officeBox.innerHTML = address;
                officeMap.innerHTML = footerMapHTML;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;

                const officeDesktopMap = document.querySelector('.location-desktop-bg');
                officeDesktopMap.style.backgroundImage = `url('${footer_map}')`;
            }
        }
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButton = document.querySelector('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButton && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks
                    mobileButton.addEventListener('click', () => {
                        console.log('menu open');
                        drawer.open();
                    });

                    /**
                     * Close Button
                     */
                    const closeButton = document.querySelector('.close__mobileMenu');

                    closeButton.addEventListener('click', () => {
                        console.log('menu closed');
                        drawer.close()
                    });

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },
    removeEmptyTOCs() {
        if (window.innerWidth >= 992) {
            if (!document.querySelector('#toc-table li')) {
            document.getElementById('toc-table').closest('.sidebar-item').remove();
            }
        } else {
            if (!document.querySelector('#toc-table-mobile li')) {
            document
                .getElementById('toc-table-mobile')
                .closest('.sidebar-item')
                .remove();
            }
        }
    },
    //home page PA accordions - show first item only if <desktop
    accordionOpen() {
        const accordions = document.querySelectorAll('.pa__items .accordion-item');
        for(let i = 0; i < accordions.length; i++) {
            const accordion = accordions[i];
            const accordButton = accordion.querySelector('.accordion-button');
            const accordBody = accordion.querySelector('.accordion-collapse');
            if(window.innerWidth >= 992) {
                if(accordButton) {
                    accordButton.classList.remove('collapsed');
                }
                if(accordBody) {
                    accordBody.classList.add('show');
                }
            } else {
                if(i === 0) {
                    if(accordButton) {
                        accordButton.classList.remove('collapsed');
                    }
                    if(accordBody) {
                        accordBody.classList.add('show');
                    }
                } else {
                    if(accordButton) {
                        accordButton.classList.add('collapsed');
                    }
                    if(accordBody) {
                        accordBody.classList.remove('show');
                    }
                }
            }
        }
    },
    desktopMenuHover() {
        const menus = document.querySelectorAll('#nav-desktop .dropdown');
        menus.forEach(menu => {
            menu.addEventListener("mouseover", function( event ) {
                menu.querySelector('.dropdown-toggle').classList.add('show');
              }, false);
              menu.addEventListener("mouseleave", function( event ) {
                menu.querySelector('.dropdown-toggle').classList.remove('show');
              }, false);
        });
    },
    paGridBorderAdjust() {
        const grid = document.querySelectorAll('.pa__layout--1 .pa__item-wrap');
        let modulo = 0;
        if(grid) {
            this.paGridSetBorderBottom();
            if(window.innerWidth >= 1200) {
                let divisor = 4;
                if(document.body.classList.contains('page-template-legal-resources')) {
                    divisor = 3;
                }
                modulo = grid.length % divisor;
                if(modulo == 0) {
                    modulo = divisor;
                }
                for(let i = grid.length - modulo; i <= grid.length -1; ++i ) {
                    if(grid[i]) {
                        grid[i].style.borderBottom = "0";
                    }
                }
            } else if(window.innerWidth >= 992) {
                modulo = grid.length % 3;
                if(modulo === 0) {
                    modulo = 3;
                }
                for(let i = grid.length - modulo; i <= grid.length -1; ++i ) {
                    if(grid[i]) {
                        grid[i].style.borderBottom = "0";
                    }
                }
            } else if(window.innerWidth >= 768) {
                modulo = grid.length % 2;
                if(modulo === 0) {
                    modulo = 2;
                }
                console.log(modulo);
                for(let i = grid.length - modulo; i <= grid.length -1; ++i ) {
                    if(grid[i]) {
                        grid[i].style.borderBottom = "0";
                    }
                }
            }
        }
    },
    paGridSetBorderBottom() {
        const grid = document.querySelectorAll('.pa__layout--1 .pa__item-wrap');
        grid.forEach(item => {
            item.style.borderBottom = "2px solid rgba(0, 0, 0, 0.1)";
        });
    }
}

export default CwThemeFramework;